
import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum";

import * as appsettings from "../appsettings";
import * as dialog from '../dialog';
import * as main from "../main";
import * as navigation from "../navigation";
import * as viewmode from "../viewmode";


export function showItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // dataItem
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as OverviewVM;

    // Edit mode form
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("WebService/Edit?webServiceId=" + dataItem.WebServiceID + "&breadcrumbLabel=" + encodeURIComponent(dataItem.WebServiceID));
}

export function editItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // dataItem
    const dataItem = this.dataItem($(e.currentTarget).closest("tr"));

    // Edit mode form
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("WebService/Edit?webServiceId=" + dataItem.WebServiceID + "&breadcrumbLabel=" + encodeURIComponent(dataItem.WebServiceID));
}

export function deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    const event = e;
    const data = this;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid) {
        // Prevent default behaviour
        e.preventDefault();

        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as OverviewVM;
        deleteWebService(dataItem.WebServiceID);
    }

    function callingCallback() {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}


export function deleteWebService(webServiceId: number): void {

    $.ajax({
        type: "POST",
        url: appsettings.getUrl("WebService/Delete?webServiceId=" + webServiceId),
        success: function (responseData: responseModel | undefined | null) {

            if (responseData != undefined && responseData != null) {
                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ', responseData.Message,
                        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                }
            }

            navigation.navigateToSpecificUrl("WebService/Overview");
        }
    });

}

